@if (isValidField()) {
  <span
    class="form-text text-danger">
    {{ getFieldError() }}
  </span>
}
